const CHAT_ICON_TYPES = {
  IMAGE: 'image',
  HELP: 'help',
  TEXT: 'text',
  SMILE: 'smile',
  DEFAULT: 'default',
};

export default CHAT_ICON_TYPES;
